<template>
  <div class="baseInfo" ref="baseInfo">
    <disposalProgress
      v-if="baselist"
      :flowid="flowid"
      :data="baselist"
      :btnlist="btnlist"
      :historyInfo="historyInfo"
      :addressInfo="addressInfo"
      @confirmReceipt="confirmReceipt"
      @eleHeight="setHeight"
    />
    <!-- <div class="baseinfo-inner" :style="`paddingTop:${disposalProgressHeight + 79}px;`"> -->
    <div class="baseinfo-inner">
      <!-- 督办消息提示 -->
      <div v-if="haveNewOversee" ref="notice" class="noticebar" @click="oversee">
        <van-cell :title="`该退货单有${overseeList.length}条督办信息`" value="查看详情" :icon="warningIcon" is-link></van-cell>
      </div>
      <div class="shadow">
        <!-- <p class="title">商品</p> -->
        <p class="title">基本信息</p>
        <!-- <div class="item item2">
          <div style="display: flex;align-items: center;position: relative;">
            <span class="name">退货人</span>
            <span class="t_info">{{ baselist.purchaser }}</span>
            <a class="call-icon call-icon1" :href="'tel:' + baselist.telephone"></a>
          </div>
          <div class="returner-detail" @click="seeReturnerDetail">
            <span>详情</span>
            <img src="../../../../assets/refund/right-jiantou.png" alt="">
            <img class="" src="https://img0.baidu.com/it/u=561041293,259965800&fm=26&fmt=auto&gp=0.jpg" alt />
            <van-icon size="12" name="arrow" />
          </div>
        </div> -->
        <div class="tuihuoren-detail">
          <div class="name">
            <span class="text">{{ hideName(baselist.submitUser) }}</span>
            <span class="tag">退货人</span>
          </div>
          <p class="carId">身份证号：{{ hideCode(baselist.submitUserIdCard) }}</p>
          <div class="shifoubenren">
            <p>是否本人购买：{{ baselist.isSelf == 1 ? '是' : '否' }}</p>
            <p v-if="baselist.isSelf !== 1" @click="seeReturnerDetail">
              <span>详情</span>
              <van-icon name="arrow" />
            </p>
          </div>
          <van-grid :column-num="2" class="info-grid" :border="false">
            <van-grid-item @click="callReturnerPhone">
              <div>
                <img src="../../../../assets/refund/icon_Connection@2x(1).png" alt="">
                <span>电话联系</span>
              </div>
            </van-grid-item>
            <van-grid-item>
              <div @click="communicationHandle">
                <div v-if="onlineWechat" class="dot"></div>
                <img src="../../../../assets/refund/icon_Connection@2x.png" alt="">
                <span>在线沟通</span>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
        <div class="item">
          <span class="name">退货原因</span>
          <span class="t_info">{{ baselist.refundReason | refundReasonFilt }}</span>
          <!-- <span class="add_text">这是一个测试间距的问题，这是一个测试间距，这个一个测试间距这是一个测试间距，这个测试监护仪</span> -->
        </div>
        <div class="item">
          <span class="name">购买渠道</span>
          <span class="t_info">{{ baselist.purchaseChannel | filt3 }}</span>
          <div @click="seeItineraryNo" v-if="baselist.purchaseChannel === 1" class="view-itinerary">查看行程单</div>
        </div>
        <div class="item">
          <span class="name">退货方式</span>
          <span v-if="baselist.finalRefundTypes" class="t_info">{{ getReturnMethod(baselist.finalRefundTypes) }}</span>
          <span v-else class="t_info">{{ getReturnMethod(baselist.refundType) }}</span>
          <div
            v-if="btnlist.includes('MODIFY_REFUND_METHOD')"
            @click="changeReturnMethod"
            class="view-itinerary"
          >变更</div>
        </div>
        <div class="item illustrate-item">
          <span class="name">补充说明</span>
          <span
            v-if="baselist && baselist.refundContent"
            class="t_info"
          >{{ baselist.refundContent }}</span>
          <span v-else class="t_info">{{ '无' }}</span>
        </div>
        <!-- <div class="item">
        <span class="name1">{{baselist.product}}</span>
        <span class="price_statusNo" v-if="!baselist.isCenterReceipt&&baselist.refundType==10">垫付金未归还</span>
        <span class="price_status" v-if="baselist.isCenterReceipt&&baselist.refundType==10">垫付金已归还</span>
        <span class="address1">商品名称</span>
        <div class="add_text">
          <span class="title_t">{{baselist.product}}</span>
          {{baselist.product}}
          午安哈侧事故发生发顺丰身份
          <span
            class="price_statusNo"
            v-if="!baselist.isCenterReceipt&&baselist.refundType==10"
          >垫付金未归还</span>
          <span class="price_status" v-if="baselist.isCenterReceipt&&baselist.refundType==10">垫付金已归还</span>
        </div>
        </div>-->
        <!-- <div class="item">
        <span class="name">购物金额</span>
        <span class="t_info">￥{{baselist.shoppingAmount}}</span>
      </div>
      <div class="item">
        <span class="name">商品类型</span>
        <span class="t_info">{{baselist.productTypes|filt1}}</span>
      </div>

      <div class="item" @click="callPhone(baselist.telephone)">
        <span class="name">联系电话</span>
        <span class="t_info" style="color:#36B374;">{{baselist.telephone}}</span>
      </div>
      <div class="item">
        <span class="name">身份证</span>
        <span class="t_info" v-if="baselist.paperwork">{{baselist.paperwork|filt5()}}</span>
        </div>-->
        <!-- <div class="item">
        <span class="address">购买地</span>
        <span class="add_text" v-if="baselist.geography">{{baselist.geography}}</span>
        <span class="add_text" v-if="baselist.geography">武汉市江夏区总部地点测试测试有一点地点测试测试有一点</span>
        </div>-->
        <!-- <div class="item">
        <span class="name">商家名称</span>
        <span class="t_info">{{baselist.shoppingStore}}</span>
        </div>-->
        <!-- <div class="item">
        <span class="address">商家地址</span>
        <span class="add_text">{{baselist.shoppingAddress}}</span>
        <span class="add_text">武汉市江夏区武汉市江夏区武汉光谷大道，武汉市江西区测试发放极道少女测试各价位自建房</span>
        </div>-->

        <!-- <div class="item" v-if="imgList&&imgList.length>0">
        <p class="proof">投诉诉求</p>
        <div class="about_img">
          <img
            :src="item"
            v-for="(item,index) in imgList"
            :key="index"
            @click="showViewer(index, $event)"
          />
        </div>
        </div>-->
        <!-- <div class="item" v-if="aboutList&&aboutList.length>0">
        <p class="proof">补充证据{{orderNumber}}</p>
        <div class="about_img">
          <img
            :src="item"
            v-for="(item,index) in aboutList"
            :key="index"
            @click="showViewer1(index, $event)"
          />
        </div>
        </div>-->
      </div>
      <div class="shadow">
        <p class="title mb15">退货商品</p>
        <div class="goods-list">
          <div v-for="(item, index) in productlist" :key="index" class="good-item">
            <div class="good-info">
              <p>{{ item.itemName }}</p>
              <p>类型：{{ getProductType(item.productTypes) }}类</p>
              <p>商品总数：{{ item.num }}件</p>
            </div>
            <div class="price">￥{{ item.amount }}</div>
          </div>
        </div>
        <div class="item">
          <span class="name mr-14">合计退货件数</span>
          <span class="t_info tuihuoshu">{{ totalAmount() }}</span>
        </div>
        <div class="item">
          <span class="name mr-14">预计退款金额</span>
          <span class="t_info tuikuanjine">￥{{ baselist.shoppingAmount | toThousands }}</span>
        </div>
        <div v-if="baselist && baselist.amount" class="item">
          <span class="name mr-14">实际退款金额</span>
          <span class="t_info">￥{{ baselist.amount | toThousands }}</span>
        </div>
        <div class="certificate-item">
          <p class="certificate" :style="{'margin-bottom': imgList.length > 0 ? '12px' : '0'}">购买凭证</p>
          <div class="img-list">
            <img
              :src="item.fileUrl"
              v-for="(item, index) in imgList"
              :key="index"
              @click="showViewer(index, $event)"
            />
          </div>
        </div>
        <div class="item">
          <span class="name">购买时间</span>
          <span class="t_info">{{baselist.shoppingTime|filt4()}}</span>
        </div>
        <div class="item store-item">
          <span class="name">销售企业</span>
          <span class="t_info">{{baselist.shoppingStore }}</span>
          <div v-if="baselist.storeTel"  @click="call('拨打该企业电话？', baselist.storeTel, 2)" class="call-icon"></div>
            <!-- <img class="call-icon" src="../../../../assets/refund/icon_Connection@2x(1).png" alt=""> -->
        </div>
        <div class="item">
          <span class="name">购买区域</span>
          <span class="t_info">{{baselist.geography }}</span>
        </div>
        <div class="item">
          <span class="name">购买地址</span>
          <span class="t_info t_info1">{{ baselist.shoppingAddress }}</span>
        </div>
        <!-- <div class="item item2">
          <div style="display: flex;align-items: center;position: relative;">
            <span class="name">商家名称</span>
            <span class="t_info">{{ baselist.shoppingStore }}</span>
            <a class="call-icon" :href="'tel:' + baselist.storeTel"></a>
          </div>
          <div class="returner-detail">
            <span>详情</span>
            <van-icon size="12" name="arrow" />
          </div>
        </div> -->
      </div>
      <div class="shadow">
        <p class="title">其他</p>
        <div class="item">
          <span class="name">退货单号</span>
          <span class="color-171A1D t_info">{{baselist.orderNumber}}</span>
        </div>
        <div class="item">
          <span class="name">申请时间</span>
          <span class="t_info color-171A1D">{{baselist.refundTime | filt}}</span>
        </div>
        <div class="item">
          <span class="name">退货渠道</span>
          <span class="t_info color-171A1D">{{ getReturnChannel(baselist.refundChannel) }}</span>
        </div>
      </div>
    </div>
    <call-phone ref="callPhone" :combinPhone="combinPhone"></call-phone>
  </div>
</template>
<script>
    import moment from 'moment';
    import { mapState } from 'vuex';
    import api from '../../../../service/modules/refund';
    import instantMessagingApi from '@/service/modules/instantMessaging';
    import util from '../../../../utils/common';
    import callPhone from '../../../../components/callPhone';
    import disposalProgress from './disposalProgress';
    import { navigateToItineraryUniversal } from '@/router/navigate';
    import Vue from 'vue';
    import { Dialog, Notify } from 'vant';

    Vue.use(Dialog);
    Vue.use(Notify);

    export default {
        filters: {
            filt (value) {
                return util.getStampInDate(value, '/');
            },
            refundReasonFilt (val) {
                const config = {
                    '1': '价格虚高',
                    '2': '瑕疵商品',
                    '3': '发票/收据不正规',
                    '4': '导游强制购物',
                    '5': '不喜欢',
                    '6': '其他'
                };
                return config[val];
            },
            filt1 (value) {
                const config = {
                    APPLICATION: 'App在线退货',
                    APPLETS: '小程序在线退货',
                    TELEPHONE_FOR_96301: '96301电话退货',
                    SYSTEM_ENTRY: '系统录入',
                    VOICE: 'App语音退货',
                    OLD_APP: '在线退货',
                    SYSTEM_ENTRY_TELEPHONE: '系统录入-现场退货',
                    SYSTEM_ENTRY_AGENCY: '系统录入-电话退货',
                    CREDIT_CODE: '诚信码',
                    CITY_SERVICE: '城市服务'
                };
                return config[value];
                // var config = util.getJsonLocal("configList").PRODUCT_TYPE;
                // let name = "";
                // if (config && config.length > 0) {
                //   config.map((item, index) => {
                //     if (item.code == value) {
                //       name = item.name;
                //     }
                //   });
                // }

                // return name;
            },
            filt2 (value, getDictType) {
                var config = util.getJsonLocal('configList').REFUND_CHANNEL;
                let name = '';
                if (config && config.length > 0) {
                    config.map((item, index) => {
                        if (item.code == value) {
                            name = item.name;
                        }
                    });
                }
                return name;
            },
            filt4 (value) {
                return moment(value).format('YYYY/MM/DD');
            },
            filt3 (val) {
                const option = {
                    1: '跟团期间购买',
                    2: '自己出行购买'
                };
                return option[val];
            },
            filt5 (value) {
                var str1 = value.slice(0, 6);

                var str2 = '';

                var str3 = value.slice(14);

                if (value.length === 15) {
                    str2 = '******';
                } else {
                    str2 = '********';
                }

                return str1 + str2 + str3;
            }
        },
        props: [
            'baselist',
            'addressInfo',
            'flowid',
            'attachments',
            'productlist',
            'historyInfo',
            'btnlist'
        ],
        components: {
            'call-phone': callPhone,
            disposalProgress
        },
        data () {
            return {
                onlineWechat: false,
                warningIcon: require('../../../../assets/refund/icon_warning@2x2.png'),
                combinPhone: 0,
                showImg: false,
                currentImageIndex: 0,
                orderNumber: '',
                regionCode: '',
                imgList: [], // 购买凭证
                aboutList: [],
                city: '',
                isViewerShow: false,
                isViewerShow1: false,
                viewerIndex: 0,
                viewerIndex1: 0,
                imgs: [],
                disposalProgressHeight: 0, // 子组件disposalProgress的高度
                timer: null, // 定时获取督办
                oldOverseeListLength: '', // 督办列表长度，用于判断是否有新的督办
                haveNewOversee: false, // 是否有新的督办
                overseeList: [], // 督办列表
                dictType: '',
                groupState: 0, // 群聊状态, 1为订单号异常， 2为群组未创建， 3为群组已创建
                detailInfo: null, // 订单详情
                itineraryList: [], // 行程单列表
                realPhone: '', // 接口换取的明文号码
                phoneBasicId: '', // 明文号码对应的退货单 basicId
                gettingPhone: false // 取号中，用于防重复点击
            };
        },
        computed: {
            ...mapState('refund', ['userInfo']),
            currentUserId: function () {
                return `yjg_${this.userInfo.id}`;
            },
            customId: function () {
                if (!this.detailInfo) {
                    return null;
                }
                return `yyn_${this.detailInfo.userId}`
            },
            refundId: function () {
                if (!this.detailInfo) {
                    return null;
                }
                return `REFUND-${this.detailInfo.orderNumber}`
            }
        },
        created () {
          console.log('userInfo', this.userInfo)
            this.getDictType();
            this.getImg();
            this.getDetail();
            this.timer = setInterval(() => {
                this.getDetail();
            }, 20 * 1000);
            console.log('545465', this.baselist);
            console.log('detailInfo', this.detailInfo);
        },
        beforeRouteLeave (to, from, next) {
            // 清除定时器
            clearInterval(this.timer);
            next();
        },
        beforeDestroy () {
            clearInterval(this.timer);
            // 取号遮罩兜底清理
            this.$Toast.clear();
        },
        mounted () {
        },
        methods: {
            call (title, telephone, operatingType) {
              this.util.callConfirm(title || '', telephone, operatingType)
            },
            // 电话联系（退货人）：详情下发的号码是掩码/密文，先换取明文再走确认弹框
            callReturnerPhone () {
                if (this.gettingPhone) return;
                const basicId = this.baselist && this.baselist.basicId;
                if (!basicId) {
                    return this.showPhoneError();
                }
                // 同一张退货单只取一次
                if (this.realPhone && this.phoneBasicId === basicId) {
                    return this.util.callConfirm('拨打该号码？', this.realPhone, 1);
                }
                this.gettingPhone = true;
                // 取号遮罩：forbidClick 会挂透明遮罩，期间界面不可操作
                const toast = this.$Toast.loading({
                    duration: 0,
                    message: '获取中...',
                    forbidClick: true
                });
                api.getPhone({ basicId }).then(res => {
                    if (this._isDestroyed) return;
                    // 号码为空、仍带掩码、或不是号码格式（如后端误返回对象），都视为取号失败
                    const phone =
                        res && res.ret === 0 && res.data != null
                            ? String(res.data).trim()
                            : '';
                    if (/^[\d+\-\s()]{5,25}$/.test(phone)) {
                        this.realPhone = phone;
                        this.phoneBasicId = basicId;
                        // 先挂监听再 clear，等遮罩淡出动画结束才弹确认框，避免两个弹层同时出现
                        this.showPhoneConfirm(phone, toast);
                        this.$Toast.clear();
                        return;
                    }
                    this.gettingPhone = false;
                    this.$Toast.clear();
                    // ret 非 0 时 http.js 已提示后端 msg，这里不重复提示
                    if (res && res.ret === 0) {
                        this.showPhoneError();
                    }
                }).catch(err => {
                    this.gettingPhone = false;
                    this.$Toast.clear();
                    if (this._isDestroyed) return;
                    // 业务错误（带 ret）已由 http.js 提示，只有网络异常才需要前端兜底
                    if (err && typeof err.ret !== 'undefined') return;
                    this.showPhoneError();
                });
            },
            // 等取号遮罩淡出结束（Toast 的 closed 事件）再弹确认框；遮罩被提前关闭等极端情况下兜底 800ms
            showPhoneConfirm (phone, toast) {
                let confirmed = false;
                const confirm = () => {
                    if (confirmed) return;
                    confirmed = true;
                    this.gettingPhone = false;
                    if (this._isDestroyed) return;
                    this.util.callConfirm('拨打该号码？', phone, 1);
                };
                if (toast && toast.$once) {
                    toast.$once('closed', confirm);
                    setTimeout(confirm, 500);
                    return;
                }
                confirm();
            },
            showPhoneError () {
                this.$Toast({
                    message: '获取号码失败，请稍后重试',
                    duration: 2000,
                    forbidClick: true
                });
            },
            hideCode (val) {
                const strLen = val.length
                let newStr = val.substr(0, 1)
                for (let i = 0; i < strLen - 2; i++) {
                    newStr += '*'
                }
                newStr += val.charAt(val.length - 1)
                return newStr
            },
            hideName (val) {
                const strLen = val.length
                let newStr = val.substr(0, 1)
                for (let i = 0; i < strLen - 1; i++) {
                    newStr += '*'
                }
                return newStr
            },
            // 查看行程单
            seeItineraryNo () {
                console.log('itineraryList', this.itineraryList)
                if (this.itineraryList && this.itineraryList.length > 0) {
                    if (this.itineraryList[0].itineraryNo && this.itineraryList[0].itineraryNo !== '1') {
                        const param = {
                            itineraryNo: this.itineraryList[0].itineraryNo
                        }
                        // api.UrlByItineraryNo(param).then(r => {
                        //     if (r.ret === 0) {
                        //         window.location.href = r.msg
                        //     } else {
                        //         this.$toast({
                        //             message: r.msg
                        //         });
                        //     }
                        // })
                        navigateToItineraryUniversal(param.itineraryNo, 'team-supervision')
                    } else {
                        console.log(this.itineraryList[0].attach, 'nghihhk')
                        this.$router.push({
                            path: '/refund/itinerary',
                            query: {
                                imgs: this.itineraryList[0].attachUrls
                            }
                        })
                    }
                } else {
                    this.$toast({
                        message: '该退货单未关联行程单'
                    });
                }
            },
            // 获取基础枚举
            getDictType () {
                api.typePicker().then(res => {
                    if (res.ret === 0) {
                        if (res.data && res.data.REFUND_CHANNEL) {
                            this.dictType = res.data.REFUND_CHANNEL;
                        }
                    }
                });
            },
            // 变更退货方式
            changeReturnMethod () {
                try {
                    this.$router.push({
                        path: '/refund/accpet',
                        query: {
                            number: this.baselist.orderNumber,
                            flowId: this.flowid,
                            finalRefundTypes: this.baselist.finalRefundTypes || this.baselist.refundType
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            },
            // 退货渠道
            getReturnChannel (val) {
                let name = '';
                if (this.dictType) {
                    this.dictType.map(item => {
                        if (item.code === val) {
                            name = item.name;
                        }
                    });
                }
                return name;
            },
            // 查看督办
            oversee () {
                console.log(this.overseeList[0])
                if (this.overseeList.length > 1) {
                    this.$router.push({
                        path: '/refund/overseelist',
                        query: {
                            data: JSON.stringify(this.baselist)
                        }
                    });
                } else if (this.overseeList.length === 1) {
                    this.$router.push({
                        path: '/refund/oversee',
                        query: {
                            detail: JSON.stringify(this.overseeList[0]),
                            flowId: this.flowid
                        }
                    });
                }
            },
            // 获取详情
            getDetail () {
                try {
                    api.detailList({ flowId: this.flowid }).then(res => {
                        if (res.ret === 0) {
                            this.detailInfo = res.data.detail;
                            this.queryUnread(res.data.detail.orderNumber);
                            if (this.oldOverseeListLength === '') {
                                this.oldOverseeListLength = res.data.refundOverSeeList.length;
                            }
                            this.overseeList = res.data.refundOverSeeList;
                            this.haveNewOversee = this.overseeList.length > 0
                            // 如果长度跟旧的一样代表没数据，隐藏
                            // if (
                            //     res.data.refundOverSeeList.length !== this.oldOverseeListLength
                            // ) {
                            //     this.haveNewOversee = true;
                            //     this.oldOverseeListLength = res.data.refundOverSeeList.length;
                            // } else {
                            //     this.haveNewOversee = false;
                            // }
                            this.itineraryList = res.data.itineraryList
                            // this.itineraryList = res.data.attachments.itinerary
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取子组件的高度，设置本页面的paddingtop
            setHeight (val) {
                this.disposalProgressHeight = val;
            },
            callPhone (value) {
                this.combinPhone = parseInt(value);
                this.$refs.callPhone.showBox();
            },
            showViewer1 (index) {
                // this.$ImagePreview({ images: this.aboutList, startPosition: index, closeOnPopstate: true });
                this.$router.push({
                    path: '/complaint/imagesView',
                    query: {
                        imageList: this.aboutList || [],
                        index
                    }
                });
                // this.viewerIndex1 = index;
                // this.isViewerShow1 = true;
            },
            // 查看退货人详情
            seeReturnerDetail () {
                this.$router.push({
                    path: '/refund/returnerDetails',
                    query: {
                        detailinfo: this.baselist
                    }
                });
            },
            // 查看购买人详情
            seePurchaserDetails () {
                this.$router.push({
                    path: '/refund/purchaserDetails',
                    query: {
                        detailinfo: this.baselist
                    }
                });
            },
            confirmReceipt () {
                this.$emit('confirmReceipt');
            },
            showViewer (index) {
              window.history.pushState(null, null, "#");
                const that = this
              const imgUrlList = []
              this.imgList.map(i => {
                  imgUrlList.push(i.fileUrl)
              })
              // this.$router.push({
              //   path: '/refund/ImagePreview',
              //   query: {
              //     images: imgUrlList,
              //     index
              //   } 
              // })
                this.$ImagePreview({
                    images: imgUrlList,
                    startPosition: index,
                    onClose() {
                      console.log('that.$router', that.$route.path);
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('refund') === -1) {
                        that.$router.back()
                      }
                    }
                });
            },
            // 总商品件数
            totalAmount () {
                let num = 0;
                this.productlist.map(item => {
                    num += item.num;
                });
                return num;
            },
            // 退款总金额
            totalMoney () {
                let total = 0;
                this.productlist.map(item => {
                    total += item.amount;
                });
                return total;
            },
            // 商品类型
            getProductType (val) {
                const option = {
                    'JADE': '珠宝玉石',
                    'TEA': '普洱茶',
                    'SILVER': '银制品',
                    'MEDICINAL_MATERIAL': '药材',
                    'OTHER': '其他'
                }
                return option[val]
            },
            getImg (orderNumber) {
                if (this.attachments) {
                    const {
                        originate,
                        feedbackVerify,
                        overseeContent,
                        centerExpress,
                        overseeFeedbackContent
                    } = this.attachments;
                    this.imgList = originate;
                }
                if (orderNumber) {
                    api.refundImg({ orderNumber: orderNumber }).then(res => {
                        if (res.data) {
                            this.imgList = res.data.evidenceImg;
                            this.aboutList = res.data.replenishEvidenceImg;
                            console.log(this.imgList);
                        }
                    });
                }
            },
            // 退货方式
            getReturnMethod (val) {
                const option = {
                    2: '现场退货',
                    1: '邮寄退货',
                    3: '委托存放',
                    4: '委托邮寄'
                };
                return option[val];
            },
            shopCity (regionCode) {
                api.getCity({ regionCode: regionCode }).then(res => {
                    if (res.ret === 0) {
                        this.city = res.data[0].name;
                    }
                });
            },
            async communicationHandle () {
                console.log('在线沟通', this.groupState);
                console.log(this.currentUserId, this.customId, this.refundId);
                if (!this.detailInfo.userId) {
                    return Dialog.alert({
                        message: '游客尚未注册游云南账号，不支持在线聊天。请联系游客，用退货手机号注册游云南账号后再发起聊天。'
                    });
                }
                if (this.detailInfo.refundChannel !== 10) {
                    return Dialog.alert({
                        message: '游客使用游云南App版本过低，不支持在线聊天。请联系游客，升级游云南App最新版本后再发起聊天。'
                    });
                }
                if (this.groupState === 2) {
                    await this.createGroup();
                } else if (this.groupState === 3) {
                }
                await this.addMembers();
                instantMessagingApi.chatAction({
                    groupId: this.refundId,
                    fromUserId: this.currentUserId
                }).then(() => {
                    let value = {
                        userId: this.currentUserId,
                        refundId: this.refundId
                    };
                    let str = [];
                    for (let key in value) {
                        str.push(key + '=' + value[key]);
                    }
                    let query = str.join('&');
                    if (process.env.NODE_ENV === 'development') {
                        // this.$router.push({
                        //     path: `/instantMessaging?${query}`
                        // })
                        window.location.href = `http://localhost:8080/#/instantMessaging?${query}`;
                    }
                    localStorage.setItem('refundId', this.refundId) // 保存到本地，app跳转之后拿不到
                    window.yyn.invokeJSB(
                        'openWindow',
                        {
                            openUrl: `${this.globalApp.getSystemInfo().host}web/#/instantMessaging?${query}`,
                            isFullScreen: 1,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            console.log(cb, 'callback');
                        }
                    );
                })
            },
            queryUnread (orderNumber) {
                if (this.groupState === 1) {
                    return false;
                }
                instantMessagingApi.checkChat({
                    groupId: this.refundId,
                    fromUserId: this.currentUserId
                }).then(res => {
                    res.errorcode = Math.abs(res.errorcode);
                    this.groupState = res.errorcode;
                    if (res.errorcode === 1) {
                        Notify({ type: 'danger', message: res.msg });
                    }
                    if (res.data && res.data.data && res.data.data.enableChat === 0) {
                        this.onlineWechat = !res.data.data.hasNoReadMsg;
                    }
                })
            },
            async createGroup () {
                const memberList = [];
                memberList.push({
                    memberAccount: this.currentUserId,
                    appMemberDefinedData: [
                        {
                            key: 'Role_Name',
                            value: this.userInfo.orgName
                        }
                    ]
                });
                memberList.push({
                    memberAccount: this.customId,
                    appMemberDefinedData: [
                        {
                            key: 'Refund_User',
                            value: '退货人'
                        }
                    ]
                });
                await instantMessagingApi.importAccount({
                    nick: this.userInfo.name,
                    identifier: this.currentUserId
                });
                await instantMessagingApi.importAccount({
                    nick: this.detailInfo.submitUser,
                    identifier: this.customId
                });
                instantMessagingApi.createGroup({
                    groupId: this.refundId,
                    introduction: `「${this.detailInfo.submitUser}」退货服务窗`,
                    name: `${this.detailInfo.submitUser}`,
                    notification: `「${this.detailInfo.submitUser}」退货服务窗群公告`,
                    ownerUserId: this.currentUserId,
                    memberList: memberList
                })
            },
            async addMembers () {
                const memberList = [];
                memberList.push({
                    memberAccount: this.currentUserId,
                    appMemberDefinedData: [
                        {
                            key: 'Role_Name',
                            value: this.userInfo.orgName
                        }
                    ]
                });
                await instantMessagingApi.importAccount({
                    nick: this.userInfo.name,
                    identifier: this.currentUserId
                });
                await instantMessagingApi.addMembersWithInfo({
                    groupId: this.refundId,
                    memberList: memberList
                })
            }
        }
    }
</script>
<style scoped lang="less">
.baseInfo {
  width: 100%;
  // margin-top: 184px;
  padding: 0 14px 0 14px;
  // background-color: #fafafa;
  box-sizing: border-box;
  // position: fixed;
  top: 90px;
  z-index: 2;
  // transform: translateY(-60px);
  margin-top: -60px;
  padding-bottom: 90px;
  .baseinfo-inner {
    // max-height: 535px;
    overflow: auto;
    // padding-top: 195px;
    &::-webkit-scrollbar {
      display: none;
    }
    /deep/.noticebar {
      padding-top: 8px;
      background-color: #f7f8fb;
      .van-icon-arrow {
        font-size: 9px;
      }
      .van-cell__value {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }
      .van-cell__title {
        flex: 2;
      }
      .van-cell {
        background: #fff3e1;
      }
      .van-icon__image {
        position: relative;
        top: 4px;
      }
    }
    .shadow {
      // box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
      margin-bottom: 8px;
      margin-top: 12px;
      border-radius: 3px;
      overflow: hidden;
      background: white;
      padding: 20px 16px 24px 16px;
      .title {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 18px;
        font-weight: 600;
        color: #1E2226;
        // font-size: 14px;
        // color: #9b9b9b;
        // padding-top: 24px;
        // padding-left: 16px;
        // background: #ffffff;
      }
      .mb15 {
        margin-bottom: 15px;
      }
      .goods-list {
        margin-bottom: 20px;
        .good-item {
          padding: 16px 12px;
          display: flex;
          justify-content: space-between;
          background-color: #f8f9fb;
          border-radius: 4px;
          &:not(:last-child) {
            margin-bottom: 8px;
          }
          .good-info {
            p {
              &:first-child {
                font-size: 14px;
                color: #333333;
                line-height: 14px;
                margin-bottom: 12px;
                font-weight: 400;
              }
              &:not(:first-child) {
                font-size: 12px;
                color: #999999;
                line-height: 12px;
                margin-bottom: 8px;
                font-weight: 400;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 14px;
            font-weight: 500;
            color: #242629;
          }
        }
      }
    }
    /deep/.tuihuoren-detail {
      background: #F8F9FC;
      border-radius: 4px;
      padding: 17px 14px 0;
      margin-bottom: 20px;
      .van-grid {
        border-top: 1px solid #ECEDF0;
        margin-top: 13px;
      }
      .van-grid-item__content--center {
        background-color: #F8F9FC;
        div {
          display: flex;
          align-items: center;
          position: relative;
          .dot {
            position: absolute;
            width: 8px;
            height: 8px;
            top: 0;
            left: 13px;
            background-color: red;
            border-radius: 50%;
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 3px;
          }
        }
      }
      .name {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        line-height: 20px;
        .text {
          font-size: 16px;
          color: #1E2226;
          line-height: 20px;
          font-weight: 500;
          margin-right: 8px;
        }
        .tag {
          display: inline-block;
          width: 44px;
          line-height: 18px;
          text-align: center;
          border: 1px solid #C8C9CC;
          border-radius: 1px;
          color: #9DA0A4;
        }
      }
      .carId {
        font-size: 14px;
        color: #71747A;
        font-weight: 400;
        margin-bottom: 5px;
        line-height: 20px;
      }

      .shifoubenren {
        line-height: 20px;
        display: flex;
        P {
          &:first-child {
            font-size: 14px;
            color: #71747A;
            font-weight: 400;
            margin-right: 8px;
          }
          &:last-child {
            font-size: 14px;
            color: #71747A;
            font-weight: 400;
            display: flex;
            align-items: center;
          }
        }
      }

      .info-grid {
        .van-grid-item__content {
          span {
            font-weight: 500;
            font-size: 14px;
            color: #36B374;
          }
        }
      }
    }
    .item {
      position: relative;
      width: 100%;
      // padding: 8px 0;
      background: #ffffff;
      display: flex;
      // padding-left: 16px;
      // border-bottom: 1px solid #efefef;
      &:not(:last-child) {
        margin-bottom: 18px;
      }
      .name {
        min-width: 72px;
        font-size: 14px;
        color: #71747a;
      }
      span {
        display: inline-block;
      }
      .name1 {
        font-size: 15px;
        color: #4a4a4a;

        vertical-align: middle;
      }

      .price_status {
        font-size: 10px;
        color: #36b374;
        padding: 2px 7px;
        border: 1px solid #36b374;
        border-radius: 14px;
        margin-left: 6px;
        vertical-align: middle;
      }
      .price_statusNo {
        font-size: 10px;
        padding: 2px 7px;
        border-radius: 14px;
        margin-left: 6px;
        // vertical-align: middle;
        color: #ff4d4d;
        border: 1px solid #ff4d4d;
        display: inline-block;
      }
      .t_info {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        // margin-left:20px;
        // width: 60%;
        color: #242629;
        vertical-align: middle;
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // max-width: 165px;
        font-weight: 400;
        font-family: PingFangSC-Regular;
      }
      .tuihuoshu {
        font-weight: 500;
      }
      .tuikuanjine {
        font-weight: 500;
      }
      .t_info1{
        line-height: 32px;
        transform: translateY(-9.5px);
      }
      .color-171A1D {
        color: #171a1d;
      }
      .call-icon {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: middle;
        background-image: url("../../../../assets/refund/icon_ts_dh@2x.png");
        background-size: 100%;
        background-repeat: no-repeat;
        border-radius: 50%;
        margin-left: 8px;
      }
      .call-icon1 {
        position: absolute;
        right: -32px;
      }
      .returner-detail {
        font-size: 14px;
        color: #a2a3a4;
        float: right;
        display: flex;
        align-items: center;
        font-weight: 400;
        img {
          width: 12px;
          height: 12px;
          display: inline-block;
        }
        .van-icon {
          vertical-align: bottom;
        }
      }
      .view-itinerary {
        border: 1px solid #9DA0A4;
        border-radius: 2px;
        padding: 0 8px;
        line-height: 28px;
        font-size: 12px;
        color: #71747a;
        position: absolute;
        z-index: 1;
        right: 0;
        top: -8px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .address {
        font-size: 14px;
        display: inline-block;
        color: #9b9b9b;
        width: 80px;
        vertical-align: top;
        line-height: 1.3em;
      }
      .address1 {
        font-size: 14px;
        display: inline-block;
        color: #9b9b9b;
        width: 80px;
        vertical-align: top;
        line-height: 1.3em;
      }
      .add_text {
        width: 70%;
        display: inline-block;
        font-size: 14px;
        vertical-align: top;
        line-height: 1.3em;
        color: #4a4a4a;
        .title_t {
          line-height: 1.3em;
          display: inline-block;
          vertical-align: top;
        }
      }
      .phone {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        margin-left: 20px;
      }
      .t_text {
        line-height: 1.4em;
      }
      .proof {
        font-size: 14px;
        color: #9b9b9b;
      }
      .search {
        width: 23px;
        height: 22px;
        display: inline-block;
        vertical-align: middle;
      }
      .about_img {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        padding-bottom: 10px;
        img {
          width: 74px;
          height: 74px;
          margin-top: 12px;
          margin-right: 8px;
          border-radius: 3px;
        }
        img:nth-child(1) {
          margin-left: 0;
        }
      }
    }
    .store-item {
      align-items: center;
      margin-bottom: 18px !important;
      .t_info {
        line-height: 18px;
      }
    }
    .illustrate-item {
      .name {
        line-height: 18px;
      }
      .t_info {
        line-height: 18px;
        white-space: pre-wrap;
        max-width: none;
      }
    }
    .certificate-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 18px;
      .certificate {
        font-size: 14px;
        color: #71747a;
        font-weight: 500;
        // margin-bottom: 12px;
      }
      .img-list {
        display: flex;
        flex-wrap: wrap;
        img {
          width: 80px;
          height: 80px;
          margin-right: 8px;
          margin-bottom: 8px;
          border-radius: 4px;
        }
      }
    }
    .item1 {
      padding-top: 18px;
    }
    .item2 {
      display: flex;
      justify-content: space-between;
    }
  }
}
.mr-14 {
  margin-right: 14px;
}
.height535 {
  max-height: 535px;
}
.height620 {
  max-height: 620px;
}
</style>
